import React from 'react';
import { useData } from '../state/services';

const Loader = () => {
    const data = useData()

    if (data.status === 'loading' )
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
                <div className="w-16 h-16 border-4 border-green-500 border-dashed rounded-full animate-spin"></div>
                <p className="mt-4 text-green-400 font-medium">Loading...</p>
            </div>
        );
    else return null;
};

export default Loader;
